import { ToastCustom } from "@components";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";
import { openExpenseAttachment } from "../services";

function getErrorMessage(error: unknown): string {
	if (error instanceof AxiosError) {
		const errorData = error.response?.data as
			| { error?: { detail?: string; errors?: string[] } }
			| undefined;
		const apiMessage =
			errorData?.error?.errors?.[0] ?? errorData?.error?.detail;

		if (apiMessage) {
			return apiMessage;
		}
	}

	if (error instanceof Error) {
		return error.message;
	}

	return "Não foi possível abrir o anexo.";
}

export function useOpenExpenseAttachment() {
	return useMutation({
		mutationKey: ["expenses", "open-attachment"],
		mutationFn: (expenseId: string | number) =>
			openExpenseAttachment(expenseId),
		onError: (error) => {
			toast(
				ToastCustom({
					description: getErrorMessage(error),
					title: "Erro ao abrir arquivo",
					variant: "error",
				})
			);
		},
	});
}
